<div class="itinerary-model-content-inner">
  <div class="itinerary-model-content">
    <div class="form-container">
      <!-- Form start -->
      <form [formGroup]="importantInformationForm">
        <div>
          <!-- Mandatory Document -->
          <div class="">
            <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Mandatory Documents</ion-title>
          </div>
          <div class="ion-padding-horizontal">
            <div formGroupName="mandatoryDocuments">
              <div class="d-flex justify-content-start">
                <div class="doc-label-container">
                  <div class="input-container">
                    <label for="" class="label">Documents</label>
                  </div>
                </div>
                <div class="required-input-container">
                  <div class="input-container">
                    <label for="" class="label">Required</label>
                  </div>
                </div>
                <div class="input-notes-container">
                  <div class="input-container">
                    <label for="" class="label">Notes</label>
                  </div>
                </div>
              </div>

              <div>
                <ng-container formArrayName="data">
                  <div class="document-item-container"
                    *ngFor="let doc of mandatoryDocumentsArray().controls; index as i" [formGroupName]="i">
                    <div class="doc-label-container">
                      <div class="input-container">
                        <div
                          [ngClass]="{ 'invalid-input': checkInvalidControlInArray(mandatoryDocumentsArray(), i, 'name') }">
                          <i class="point-style-arrow"></i><input type="text" class="document-label input"
                            placeholder="Enter document label" formControlName="name">
                        </div>
                      </div>
                    </div>
                    <div class="required-input-container">
                      <div>
                        <div>
                          <ion-toggle class="align-bottom ps-1" [enableOnOffLabels]="true" formControlName="isDocumentRequired"></ion-toggle>
                        </div>
                      </div>
                    </div>
                    <div class="input-notes-container">
                      <div class="input-container">
                        <div
                          [ngClass]="{ 'invalid-input': checkInvalidControlInArray(mandatoryDocumentsArray(), i, 'note') }">
                          <input type="text" class="doc-notes-input input" placeholder="Enter notes"
                            formControlName="note">
                        </div>
                      </div>
                    </div>

                    <div class="delete-btn-container">
                      <ion-button class="delete-btn" (click)="removeMandatoryDocument(i)"><ion-icon
                          name="trash-outline"></ion-icon></ion-button>
                    </div>
                  </div>
                  <div class="w-100 py-1" *ngIf="mandatoryDocumentsArray().length === 0">
                    <p class="mb-0 text-center" style="font-size: 14px;">No Documents Added!</p>
                  </div>
                </ng-container>

                <div class="d-flex justify-content-end">
                  <ion-button class="unfilled-blue-btn" (click)="addMandatoryDocument()">
                    <ion-icon name="add-outline"></ion-icon>
                    Add Documents
                  </ion-button>
                </div>
              </div>
            </div>
          </div>

          <!-- Additional docs based on visa type -->
          <div class="mt-2">
            <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Additional Documents Based on Visa Type / Applicant Type</ion-title>
          </div>
          <div class="ion-padding-horizontal">
            <div formGroupName="documentsBasedOnVisa">
              <div class="d-flex justify-content-start">
                <div class="doc-label-container">
                  <div class="input-container">
                    <label for="" class="label">Documents</label>
                  </div>
                </div>
                <div class="required-input-container">
                  <div class="input-container">
                    <label for="" class="label">Required</label>
                  </div>
                </div>
                <div class="input-notes-container">
                  <div class="input-container">
                    <label for="" class="label">Notes</label>
                  </div>
                </div>
              </div>

              <div>
                <ng-container formArrayName="data">
                  <ng-container *ngFor="let doc of documentsBasedOnVisaType().controls; index as i" [formGroupName]="i">
                    <div class="document-item-container">
                      <div class="doc-label-container">
                        <div class="input-container">
                          <div
                            [ngClass]="{ 'invalid-input': checkInvalidControlInArray(documentsBasedOnVisaType(), i, 'name') }">
                            <i class="point-style-arrow"></i><input type="text" class="document-label input"
                              placeholder="Enter document label" formControlName="name">
                          </div>
                        </div>
                      </div>
                      <div class="required-input-container">
                        <div>
                          <div>
                            <ion-toggle class="align-bottom ps-1" [enableOnOffLabels]="true" formControlName="isDocumentRequired"></ion-toggle>
                          </div>
                        </div>
                      </div>
                      <div class="input-notes-container">
                        <div class="input-container">
                          <div
                            [ngClass]="{ 'invalid-input': checkInvalidControlInArray(documentsBasedOnVisaType(), i, 'note') }">
                            <input type="text" class="doc-notes-input input" placeholder="Enter notes"
                              formControlName="note">
                          </div>
                        </div>
                      </div>

                      <div class="delete-btn-container">
                        <ion-button class="delete-btn" (click)="removeDocumentsBasedOnVisaType(i)"><ion-icon
                            name="trash-outline"></ion-icon></ion-button>
                      </div>
                    </div>

                    <div *ngIf="checkInvalidControlInArray(documentsBasedOnVisaType(), i, 'visaTypes')">
                      <div class="input-container">
                        <p class="warning-message mb-0">Select at least one visa type</p>
                      </div>
                    </div>
                    <div class="border border-1 rounded p-1 mb-1 checkbox-container-grid">
                      <div>
                        <div class="input-container">
                          <label for="" class="label">Visa Type</label>
                        </div>
                      </div>
                      <div class="d-flex flex-wrap mb-2 px-2" *ngIf="visaTypes">
                        <div class="me-4 visa-type-item">
                          <div>
                            <input type="checkbox" name="" id="" class="me-1 align-middle"
                              (input)="toggleSelectAllVisaType($event, i)" [checked]="checkAllVisaSelected(i)">
                            <label for="" class="checkbox-label">All</label>
                          </div>
                        </div>
                        <div class="me-4 visa-type-item" *ngFor="let visa of visaTypes;">
                          <div>
                            <input type="checkbox" name="" id="" class="me-1 align-middle"
                              (input)="toggleVisaType($event, i, visa.key)"
                              [checked]="checkVisaTypeSelected(i, visa.key)">
                            <label for="" class="checkbox-label">{{visa.name}}</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div *ngIf="checkInvalidControlInArray(documentsBasedOnVisaType(), i, 'applicantTypes')">
                      <div class="input-container">
                        <p class="warning-message mb-0">Select at least one applicant type</p>
                      </div>
                    </div>
                    <div class="border border-1 border-dashed rounded p-1 checkbox-container-grid">
                      <div>
                        <div class="input-container">
                          <label for="" class="label">Applicant Type</label>
                        </div>
                      </div>
                      <div class="d-flex flex-wrap mb-2 px-2" *ngIf="applicantTypes">
                        <div class="me-4 visa-type-item">
                          <div>
                            <input type="checkbox" name="" id="" class="me-1 align-middle"
                              (input)="toggleSelectAllApplicantType($event, i)"
                              [checked]="checkAllApplicantTypeSelected(i)">
                            <label for="" class="checkbox-label">All</label>
                          </div>
                        </div>
                        <div class="me-4 visa-type-item" *ngFor="let applicant of applicantTypes">
                          <div>
                            <input type="checkbox" name="" id="" class="me-1 align-middle"
                              (input)="toggleApplicantType($event, i, applicant.key)"
                              [checked]="checkApplicantTypeSelected(i, applicant.key)">
                            <label for="" class="checkbox-label">{{applicant.name}}</label>
                          </div>
                        </div>

                      </div>
                    </div>

                    <div class="dashed-line my-2"></div>

                  </ng-container>

                  <div class="w-100 py-1" *ngIf="documentsBasedOnVisaType().length === 0">
                    <p class="mb-0 text-center" style="font-size: 14px;">No Documents Added!</p>
                  </div>
                </ng-container>

                <div class="d-flex justify-content-end">
                  <ion-button class="unfilled-blue-btn" (click)="addDocumentsBasedOnVisaType()">
                    <ion-icon name="add-outline"></ion-icon>
                    Add Documents
                  </ion-button>
                </div>
              </div>
            </div>
          </div>

          <!-- Other documents -->
          <div class="mt-2">
            <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Other Documents</ion-title>
          </div>
          <div class="ion-padding-horizontal">
            <div formGroupName="otherDocuments">
              <div class="d-flex justify-content-start">
                <div class="doc-label-container">
                  <div class="input-container">
                    <label for="" class="label">Documents</label>
                  </div>
                </div>
                <div class="required-input-container">
                  <div class="input-container">
                    <label for="" class="label">Required</label>
                  </div>
                </div>
                <div class="input-notes-container">
                  <div class="input-container">
                    <label for="" class="label">Notes</label>
                  </div>
                </div>
              </div>

              <div>
                <ng-container formArrayName="data">
                  <div class="document-item-container" *ngFor="let doc of otherDocumentsArray().controls; index as i"
                    [formGroupName]="i">
                    <div class="doc-label-container">
                      <div class="input-container">
                        <div
                          [ngClass]="{ 'invalid-input': checkInvalidControlInArray(otherDocumentsArray(), i, 'name') }">
                          <i class="point-style-arrow"></i><input type="text" class="document-label input"
                            placeholder="Enter document label" formControlName="name">
                        </div>
                      </div>
                    </div>
                    <div class="required-input-container">
                      <div>
                        <div>
                          <ion-toggle class="align-bottom ps-1" [enableOnOffLabels]="true" formControlName="isDocumentRequired"></ion-toggle>
                        </div>
                      </div>
                    </div>
                    <div class="input-notes-container">
                      <div class="input-container">
                        <div
                          [ngClass]="{ 'invalid-input': checkInvalidControlInArray(otherDocumentsArray(), i, 'note') }">
                          <input type="text" class="doc-notes-input input" placeholder="Enter notes"
                            formControlName="note">
                        </div>
                      </div>
                    </div>

                    <div class="delete-btn-container">
                      <ion-button class="delete-btn" (click)="removeOtherDocument(i)"><ion-icon
                          name="trash-outline"></ion-icon></ion-button>
                    </div>
                  </div>
                  <div class="w-100 py-1" *ngIf="otherDocumentsArray().length === 0">
                    <p class="mb-0 text-center" style="font-size: 14px;">No Documents Added!</p>
                  </div>
                </ng-container>

                <div class="d-flex justify-content-end">
                  <ion-button class="unfilled-blue-btn" (click)="addOtherDocument()">
                    <ion-icon name="add-outline"></ion-icon>
                    Add Documents
                  </ion-button>
                </div>
              </div>
            </div>
          </div>

          <!-- Keys Poins to know -->
          <div class="mt-2">
            <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Key Points to Know</ion-title>
          </div>
          <div class="ion-padding-horizontal">
            <div formGroupName="keyPoints">
              <div class="d-flex justify-content-start">
                <div class="doc-label-container">
                  <div class="input-container">
                    <label for="" class="label">Notes</label>
                  </div>
                </div>
                <div class="required-input-container">
                  <div class="input-container">
                    <label for="" class="label">Required</label>
                  </div>
                </div>
                <div class="input-notes-container">
                  <div class="input-container">
                    <label for="" class="label"></label>
                  </div>
                </div>
              </div>

              <div>
                <ng-container formArrayName="data">
                  <div class="document-item-container" *ngFor="let doc of keyPointsToNoteArray().controls; index as i"
                    [formGroupName]="i">
                    <div class="doc-label-container">
                      <div class="input-container">
                        <div
                          [ngClass]="{ 'invalid-input': checkInvalidControlInArray(keyPointsToNoteArray(), i, 'name') }">
                          <i class="point-style-arrow"></i><input type="text" class="document-label input"
                            placeholder="Enter Notes label" formControlName="name">
                        </div>
                      </div>
                    </div>
                    <div class="required-input-container">
                      <div>
                        <div>
                          <ion-toggle class="align-bottom ps-1" [enableOnOffLabels]="true" formControlName="isDocumentRequired"></ion-toggle>
                        </div>
                      </div>
                    </div>
                    <div class="input-notes-container">
                      <div class="input-container">
                        <div
                          [ngClass]="{ 'invalid-input': checkInvalidControlInArray(keyPointsToNoteArray(), i, 'note') }">
                          <input type="text" class="doc-notes-input input" placeholder="Enter notes"
                            formControlName="note">
                        </div>
                      </div>
                    </div>

                    <div class="delete-btn-container">
                      <ion-button class="delete-btn" (click)="removeKeyPointsToNote(i)"><ion-icon
                          name="trash-outline"></ion-icon></ion-button>
                    </div>
                  </div>
                  <div class="w-100 py-1" *ngIf="keyPointsToNoteArray().length === 0">
                    <p class="mb-0 text-center" style="font-size: 14px;">No Notes Added!</p>
                  </div>
                </ng-container>

                <div class="d-flex justify-content-end">
                  <ion-button class="unfilled-blue-btn" (click)="addKeyPointsToNote()">
                    <ion-icon name="add-outline"></ion-icon>
                    Add Notes
                  </ion-button>
                </div>
              </div>
            </div>
          </div>

          <!-- Prohibited/Restriced items -->
          <div class="mt-2">
            <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Prohibited/Restricted
              Items</ion-title>
          </div>
          <div class="ion-padding-horizontal">
            <div formGroupName="restrictedItems">
              <div class="d-flex justify-content-start">
                <div class="doc-label-container">
                  <div class="input-container">
                    <label for="" class="label">Notes</label>
                  </div>
                </div>
                <div class="required-input-container">
                  <div class="input-container">
                    <label for="" class="label">Required</label>
                  </div>
                </div>
                <div class="input-notes-container">
                  <div class="input-container">
                    <label for="" class="label"></label>
                  </div>
                </div>
              </div>

              <div>
                <ng-container formArrayName="data">
                  <div class="document-item-container"
                    *ngFor="let doc of prohibitedOrRestrictedItemsArray().controls; index as i" [formGroupName]="i">
                    <div class="doc-label-container">
                      <div class="input-container">
                        <div
                          [ngClass]="{ 'invalid-input': checkInvalidControlInArray(prohibitedOrRestrictedItemsArray(), i, 'name') }">
                          <i class="point-style-arrow"></i><input type="text" class="document-label input"
                            placeholder="Enter Notes label" formControlName="name">
                        </div>
                      </div>
                    </div>
                    <div class="required-input-container">
                      <div>
                        <div>
                          <ion-toggle class="align-bottom ps-1" [enableOnOffLabels]="true" formControlName="isDocumentRequired"></ion-toggle>
                        </div>
                      </div>
                    </div>
                    <div class="input-notes-container">
                      <div class="input-container">
                        <div
                          [ngClass]="{ 'invalid-input': checkInvalidControlInArray(prohibitedOrRestrictedItemsArray(), i, 'note') }">
                          <input type="text" class="doc-notes-input input" placeholder="Enter notes"
                            formControlName="note">
                        </div>
                      </div>
                    </div>

                    <div class="delete-btn-container">
                      <ion-button class="delete-btn" (click)="removeProhibitedOrRestrictedItems(i)"><ion-icon
                          name="trash-outline"></ion-icon></ion-button>
                    </div>
                  </div>
                  <div class="w-100 py-1" *ngIf="prohibitedOrRestrictedItemsArray().length === 0">
                    <p class="mb-0 text-center" style="font-size: 14px;">No Notes Added!</p>
                  </div>
                </ng-container>

                <div class="d-flex justify-content-end">
                  <ion-button class="unfilled-blue-btn" (click)="addProhibitedOrRestrictedItems()">
                    <ion-icon name="add-outline"></ion-icon>
                    Add Notes
                  </ion-button>
                </div>
              </div>
            </div>
          </div>

          <!-- Important Notes -->
          <div class="mt-2">
            <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Important Notes</ion-title>
          </div>
          <div class="ion-padding-horizontal">
            <div formGroupName="importantNotes">
              <div class="d-flex justify-content-start">
                <div class="doc-label-container">
                  <div class="input-container">
                    <label for="" class="label">Notes</label>
                  </div>
                </div>
                <div class="required-input-container">
                  <div class="input-container">
                    <label for="" class="label">Required</label>
                  </div>
                </div>
                <div class="input-notes-container">
                  <div class="input-container">
                    <label for="" class="label"></label>
                  </div>
                </div>
              </div>

              <div>
                <ng-container formArrayName="data">
                  <div class="document-item-container" *ngFor="let doc of importantNotesArray().controls; index as i"
                    [formGroupName]="i">
                    <div class="doc-label-container">
                      <div class="input-container">
                        <div
                          [ngClass]="{ 'invalid-input': checkInvalidControlInArray(importantNotesArray(), i, 'name') }">
                          <i class="point-style-arrow"></i><input type="text" class="document-label input"
                            placeholder="Enter Notes label" formControlName="name">
                        </div>
                      </div>
                    </div>
                    <div class="required-input-container">
                      <div>
                        <div>
                          <ion-toggle class="align-bottom ps-1" [enableOnOffLabels]="true" formControlName="isDocumentRequired"></ion-toggle>
                        </div>
                      </div>
                    </div>
                    <div class="input-notes-container">
                      <div class="input-container">
                        <div
                          [ngClass]="{ 'invalid-input': checkInvalidControlInArray(importantNotesArray(), i, 'note') }">
                          <input type="text" class="doc-notes-input input" placeholder="Enter notes"
                            formControlName="note">
                        </div>
                      </div>
                    </div>

                    <div class="delete-btn-container">
                      <ion-button class="delete-btn" (click)="removeImportantNotes(i)"><ion-icon
                          name="trash-outline"></ion-icon></ion-button>
                    </div>
                  </div>
                  <div class="w-100 py-1" *ngIf="importantNotesArray().length === 0">
                    <p class="mb-0 text-center" style="font-size: 14px;">No Notes Added!</p>
                  </div>
                </ng-container>

                <div class="d-flex justify-content-end">
                  <ion-button class="unfilled-blue-btn" (click)="addImportantNotes()">
                    <ion-icon name="add-outline"></ion-icon>
                    Add Notes
                  </ion-button>
                </div>
              </div>
            </div>
          </div>

          <!-- Details About Stay -->
          <div class="mt-2">
            <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Details About Stay</ion-title>
          </div>
          <div class="ion-padding-horizontal">
            <div formGroupName="detailsAboutStay">
              <div class="d-flex justify-content-start">
                <div class="doc-label-container">
                  <div class="input-container">
                    <label for="" class="label">Notes</label>
                  </div>
                </div>
                <div class="required-input-container">
                  <div class="input-container">
                    <label for="" class="label">Required</label>
                  </div>
                </div>
                <div class="input-notes-container">
                  <div class="input-container">
                    <label for="" class="label"></label>
                  </div>
                </div>
              </div>

              <div>
                <ng-container formArrayName="data">
                  <div class="document-item-container" *ngFor="let doc of detailsAboutStayArray().controls; index as i"
                    [formGroupName]="i">
                    <div class="doc-label-container">
                      <div class="input-container">
                        <div
                          [ngClass]="{ 'invalid-input': checkInvalidControlInArray(detailsAboutStayArray(), i, 'name') }">
                          <i class="point-style-arrow"></i><input type="text" class="document-label input"
                            placeholder="Enter Notes label" formControlName="name">
                        </div>
                      </div>
                    </div>
                    <div class="required-input-container">
                      <div>
                        <div>
                          <ion-toggle class="align-bottom ps-1" [enableOnOffLabels]="true" formControlName="isDocumentRequired"></ion-toggle>
                        </div>
                      </div>
                    </div>
                    <div class="input-notes-container">
                      <div class="input-container">
                        <div
                          [ngClass]="{ 'invalid-input': checkInvalidControlInArray(detailsAboutStayArray(), i, 'note') }">
                          <input type="text" class="doc-notes-input input" placeholder="Enter notes"
                            formControlName="note">
                        </div>
                      </div>
                    </div>

                    <div class="delete-btn-container">
                      <ion-button class="delete-btn" (click)="removeDetailsAboutStay(i)"><ion-icon
                          name="trash-outline"></ion-icon></ion-button>
                    </div>
                  </div>
                  <div class="w-100 py-1" *ngIf="detailsAboutStayArray().length === 0">
                    <p class="mb-0 text-center" style="font-size: 14px;">No Notes Added!</p>
                  </div>
                </ng-container>

                <div class="d-flex justify-content-end">
                  <ion-button class="unfilled-blue-btn" (click)="addDetailsAboutStay()">
                    <ion-icon name="add-outline"></ion-icon>
                    Add Notes
                  </ion-button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </form>

      <!-- Form end -->
       
    </div>


  </div>

  <div class="ion-padding-horizontal bg-light-gray justify-content-center itinerary-model-footer">
    <ion-button class="unfilled-blue-btn" (click)="goPrevious()" [disabled]="formDataModified()">
      <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="resetForm()" [disabled]="!formDataModified()">
      Reset
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="onSubmit()" [disabled]="!formDataModified() && storedFormData">
      Save
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="saveAndNext()" [disabled]="!formDataModified() && storedFormData">
      Save & Next
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="goNext()" [disabled]="formDataModified()">
      <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
    </ion-button>
  </div>
</div>